import React from "react";
import "./service_box.scss";
const ServiceBox = ({ serviceName, img, content, index }) => {
  return (
    <div className={`service_box_main sbm_${index}`}>
      <div className="service_box_container">
        <div className="service_img">
          <img src={img} alt={`${serviceName}_img`} />
        </div>
        <div className="service_words">
          <div className="service_heading">
            <h2>{serviceName}</h2>
          </div>
          <div className="service_content">
            <p>{content}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceBox;
